import React from "react";
import {AUTO_MODE} from './AppearanceSettingProvider';

export default React.createContext({
   isDarkMode: false,
   appearanceSetting: AUTO_MODE,
   setAppearanceSetting: (appearanceSetting) => {},
});
